module.exports = __webpack_public_path__ + "img/tuboDrenoAcessorio1.626c4b3d.png";